export default __webpack_public_path__ + "static/media/AirCompressorImg.ff89f41b.jpg";